<template>
  <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8 0C12.4062 0 16 3.59375 16 8C16 12.4375 12.4062 16 8 16C3.5625 16 0 12.4375 0 8C0 3.59375 3.5625 0 8 0ZM8 4C7.4375 4 7 4.46875 7 5C7 5.5625 7.4375 6 8 6C8.53125 6 9 5.5625 9 5C9 4.46875 8.53125 4 8 4ZM9.25 12C9.65625 12 10 11.6875 10 11.25C10 10.8438 9.65625 10.5 9.25 10.5H8.75V7.75C8.75 7.34375 8.40625 7 8 7H7C6.5625 7 6.25 7.34375 6.25 7.75C6.25 8.1875 6.5625 8.5 7 8.5H7.25V10.5H6.75C6.3125 10.5 6 10.8438 6 11.25C6 11.6875 6.3125 12 6.75 12H9.25Z"
      fill="#191919"
    />
  </svg>
</template>
